import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoadingService {
  private loadingMap = new Map<number, BehaviorSubject<boolean>>();

  getLoading(id: number): Observable<boolean> {
    if (!this.loadingMap.has(id)) {
      this.loadingMap.set(id, new BehaviorSubject<boolean>(false));
    }
    return this.loadingMap.get(id)!.asObservable();
  }

  setLoading(id: number, isLoading: boolean): void {
    if (!this.loadingMap.has(id)) {
      this.loadingMap.set(id, new BehaviorSubject<boolean>(false));
    }
    this.loadingMap.get(id)!.next(isLoading);
  }
}
